import { render, staticRenderFns } from "./ClientRecurrence.vue?vue&type=template&id=0d12dcf2&scoped=true"
import script from "./ClientRecurrence.vue?vue&type=script&lang=js"
export * from "./ClientRecurrence.vue?vue&type=script&lang=js"
import style0 from "./ClientRecurrence.vue?vue&type=style&index=0&id=0d12dcf2&prod&scoped=true&lang=css"
import style1 from "./ClientRecurrence.vue?vue&type=style&index=1&id=0d12dcf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d12dcf2",
  null
  
)

export default component.exports